module.exports = __webpack_public_path__ + "static/media/011-score on king.130faad8.jpeg";